import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import Arrow from './arrow';
import { GroupContext } from './group';
export var Cell = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      style = props.style,
      icon = props.icon,
      label = props.label,
      desc = props.desc,
      text = props.text,
      children = props.children,
      showArrow = props.showArrow,
      arrow = props.arrow,
      prepend = props.prepend,
      append = props.append,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      _onClick = props.onClick;
  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement(GroupContext.Consumer, null, function (_ref2) {
      var isFromGroup = _ref2.isFromGroup;
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-cell", 'all-border-box', {
          'without-group': !isFromGroup
        }, {
          bordered: bordered
        }, className),
        style: style,
        ref: domRef,
        onClick: function onClick(e) {
          return _onClick && _onClick(e);
        }
      }, prepend, /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-cell-inner", {
          'has-desc': desc
        })
      }, icon ? /*#__PURE__*/React.createElement("div", {
        className: "cell-label-icon"
      }, icon) : null, label || desc ? /*#__PURE__*/React.createElement("div", {
        className: "cell-label"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cell-title"
      }, label), desc ? /*#__PURE__*/React.createElement("div", {
        className: "cell-desc"
      }, desc) : null) : null, /*#__PURE__*/React.createElement("div", {
        className: "cell-content " + (label || desc ? 'has-label' : '')
      }, text ? /*#__PURE__*/React.createElement("div", {
        className: "cell-text"
      }, text) : null, children), showArrow ? /*#__PURE__*/React.createElement("div", {
        className: "cell-arrow-icon"
      }, arrow || /*#__PURE__*/React.createElement(Arrow, null)) : null), append);
    });
  });
});